import {pluralNumber} from '../../../utils/numerals/pluralNumber';

export const checkLoadButton = ( button, roomsLeft, nextPage ) => {
	if ( roomsLeft )
	{
		button.innerHTML = `Показать еще ${roomsLeft < 20 ? `${roomsLeft}&nbsp;${pluralNumber( roomsLeft, 'вариант', 'варианта', 'вариантов' )}` : `20&nbsp;вариантов`}`;
		button.disabled = false;
		button.dataset.nextPage = nextPage;
	}
	else
	{
		button.disabled = true;
	}
};